import jQuery from "jquery";

(function (far, $) {
    far.validation = {};

    //#region Run immediately =====================================================

    setupUnobtrusiveValidation();
    setupWarnings();

    //#endregion

    //#region Private functions ===================================================

    function setupWarnings() {
        $(".js-validate-postbox").keyup(warnIfPostBox).each(warnIfPostBox);
    }

    function setupUnobtrusiveValidation() {
        $.validator.unobtrusive = {
            options: {
                ignore: ".ignore, .hidden, :hidden",
                errorClass: "form-control--error",
                invalidHandler: onErrors,
            }
        };
    }

    // Overide på den inbyggda funktionen för att kunna hitta validation-summary-block utanför <form />
    function onErrors(event, validator) {
        var container = $("body").find("[data-valmsg-summary=true]");
        var list = container.find("ul");

        if (list && list.length && validator.errorList.length) {
            list.empty();
            container
                .addClass("validation-summary-errors")
                .removeClass("validation-summary-valid");

            $.each(validator.errorList, function () {
                $("<li />").html(this.message).appendTo(list);
            });
        }
    }

    function warnIfPostBox() {
        var $this = $(this);
        console.log($this.val());
        if ($this.val().toLowerCase().startsWith("box ")) {
            $this
                .siblings(".form-control__warning")
                .addClass("form-control__warning--show");
            $this.addClass("form-control--warning");
        } else {
            $this
                .siblings(".form-control__warning")
                .removeClass("form-control__warning--show");
            $this.removeClass("form-control--warning");
        }
    }

    //#endregion
})(window.far || (window.far = {}), jQuery);
